import { render } from "./askAQuestionPersonalForm.vue?vue&type=template&id=0de11e65&ts=true"
import script from "./askAQuestionPersonalForm.vue?vue&type=script&lang=ts"
export * from "./askAQuestionPersonalForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__